// Utility functions for WaterQualityView

export type NewItemParams = {
  parameter_smarts: string;
  result_display: string;
  units: string;
  annual_avg: string;
  number: number | null;
};

export type NewItem = {
  collectiondate: string;
  monitoringpoint: string;
  report_year: string;
  params: NewItemParams[];
};

// Function to calculate yearly averages
export const calculateYearlyAverages = (data: NewItem[], year: string, params: string[]) => {
  console.log(`Calculating averages for year: ${year}`);
  console.log(`Total data items: ${data.length}`);
  
  return params.map((param) => {
    let sum: number = 0;
    let count: number = 0;
    let unit: string = "";
    
    // Filter data only for specific year
    const yearData = data.filter(item => item.report_year === year);
    console.log(`Data for year ${year}: ${yearData.length} items`);
    
    yearData.forEach(({ params }) => {
      params.forEach(({ parameter_smarts, units, result_display }) => {
        if (param === parameter_smarts) {
          unit = units;
          console.log(`Parameter: ${param}, result_display: "${result_display}", unit: "${unit}"`);
          
          // Check that value is not empty and is a valid number
          // For pH exclude "NA", for other parameters accept all numbers
          if (result_display && 
              result_display.trim() !== '' && 
              !isNaN(Number(result_display)) && 
              (param !== "pH" || result_display !== "NA")) {
            
            // For pH exclude "NA", for others accept all numbers including 0
            if (param === "pH" && result_display === "NA") {
              console.log(`Excluding pH value: "${result_display}"`);
            } else {
              sum += Number(result_display);
              count++;
              console.log(`Valid value: ${result_display}, sum: ${sum}, count: ${count}`);
            }
          } else {
            console.log(`Invalid value: "${result_display}"`);
          }
        }
      });
    });
    
    // For non-pH parameters, show "0" instead of "N/A"
    if (param === "pH") {
      const average = count > 0 ? (sum / count).toFixed(2) : "N/A";
      console.log(`Final result for ${param}: average=${average}, unit=${unit}`);
      return { average, unit, param };
    } else {
      const average = count > 0 ? (sum / count).toFixed(2) : "0";
      console.log(`Final result for ${param}: average=${average}, unit=${unit}`);
      return { average, unit, param };
    }
  });
};
